// extracted by mini-css-extract-plugin
export default {"crBreadcrumb":"CrBreadcrumb_crBreadcrumb__HtzcR","crumb":"CrBreadcrumb_crumb__8roXm","crumbTitle":"CrBreadcrumb_crumbTitle__gZktX","crumbDivider":"CrBreadcrumb_crumbDivider__guaYg"};